<template>
  <span class="button-group">
    <div class="row" v-if="syncing">
      <loader></loader>
    </div>
    <div v-else>
      <router-link
        class="btn btn-default btn-sm"
        :to="{ name: this.consultType, params: { client_id: consult.client, season: consultSeason } }"
      >
        Open
      </router-link>
      |
      <button
        @click="canSubmit ? submitConsult() : ''"
        class="btn btn-sm btn-success"
        :class="{ disabled: !canSubmit }"
        v-tooltip="getSubmitTooltip"
        :title="getSubmitTooltip"
      >
        Submit
      </button>
      |
      <VDropdown style="display: inline" :offset="[0, 16]">
        <button class="btn btn-sm btn-default tooltip-target b3" v-tooltip="'More Options'" title="More Options">
          <span class="glyphicon glyphicon-option-vertical"></span>
        </button>

        <template #popper>
          <ul class="nav nav-pills nav-stacked">
            <li>
              <button class="btn btn-default btn-block" @click="backup" v-tooltip="'Make a backup of entered data'">
                Send Diagnostic
              </button>
            </li>
            <li>
              <button
                class="btn btn-sm btn-danger btn-block"
                v-tooltip="'Delete local copy of the Consult'"
                @click="confirmDeleteConsult"
              >
                Delete
              </button>
            </li>
          </ul>
        </template>
      </VDropdown>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { indexedDB } from '@/_helpers'
import { consultFormService } from '@/_services'
import springConsult from '@/_store/spring_consult.module'

import currentConsult from '@/_store/current_consult.module'

export default {
  name: 'SpringConsultActions',
  props: ['consult', 'consultSeason'],
  data() {
    return {
      syncing: false,
      consultType: 'spring_consult',
    }
  },
  methods: {
    ...mapActions('springConsult', ['addBackendErrors', 'saveConsultData', 'setClient']),
    ...mapActions('client', ['updateClientLastConsult']),

    submitConsult: function () {
      // set currentConsult store
      Object.assign(currentConsult.state, springConsult.stateMixin)
      Object.assign(currentConsult.actions, springConsult.actionsMixin)
      Object.assign(currentConsult.mutations, springConsult.mutationsMixin)
      Object.assign(currentConsult.getters, springConsult.gettersMixin)

      if (this.$store.hasModule('currentConsult')) {
        this.$store.unregisterModule('currentConsult')
      }
      this.$store.registerModule('currentConsult', currentConsult)

      this.$store.commit('currentConsult/setConsultType', 'springConsult')
      this.syncing = true
      let self = this

      let consultParams = { clientId: this.consult.client, season: this.consultSeason }

      this.$store.dispatch('currentConsult/setClient', this.consult.client).then(() => {
        self.$store
          .dispatch('currentConsult/saveConsultData', consultParams)
          .then(() => {
            self.$store.dispatch('alert/success', {
              message: 'Success! Data has been synced to the server.',
            })
            self.deleteConsult()

            self.$emit('consult-changed')
            self.$router.push('/')
          })
          .catch((error) => {
            if (error.response.status == 500) {
              self.$store.dispatch('alert/error', {
                message: 'An error occurred. Contact the administrator.',
              })
              let hideAlert = true
              self.backup(hideAlert)
            } else {
              if (error.response.data['consult_already_finished']) {
                self.$store.dispatch('alert/error', { message: 'Consult already finished.' })
                self.consult.models.Misc.read_only = true
                // TODO: store data on idb?
              } else {
                self.$store
                  .dispatch('currentConsult/addBackendErrors', {
                    clientId: self.consult.client,
                    errors: error.response.data,
                  })
                  .then(() => {
                    self.$router.push({
                      name: 'spring_consult',
                      params: { client_id: self.consult.client, season: self.consultSeason },
                    })
                  })
              }
            }
          })
          .finally(() => {
            self.syncing = false
          })
      })
    },
    backup: function (hideAlert) {
      // TODO: maybe add a consult type to indexedDB on backend
      this.syncing = true

      consultFormService
        .consultBackup(this.consult, this.consult.client)
        .then(() => {
          if (!hideAlert) {
            this.$store.dispatch('alert/success', { message: 'Data has been synced to the backup server.' })
          }
        })
        .catch(() => {
          if (!hideAlert) {
            this.$store.dispatch('alert/error', { message: 'An error occurred. Contact the administrator.' })
          }
        })
        .finally(() => {
          this.syncing = false
        })
    },
    deleteConsult: function () {
      var self = this
      var dbKey = this.consult.client
      var consultData = { client: this.consult.client, consultType: this.consultType }

      indexedDB.delete(dbKey, 'spring-consult').then(() => {
        self.$emit('consult-deleted', consultData)
      })
    },
    confirmDeleteConsult: function () {
      if (confirm('Do you really want to delete?')) {
        this.deleteConsult()
      }
    },
  },
  computed: {
    ...mapState('springConsult', ['backendErrors']),
    ...mapGetters('connection', ['online']),
    canSubmit: function () {
      return this.online && !this.consult.models.Misc.read_only && this.consult.models.AnimalNumbers.signed_at
    },
    getSubmitTooltip: function () {
      if (!this.online) {
        return "Please wait until you're online to submit"
      } else if (this.consult.models.Misc.read_only) {
        return 'Consult is in read only mode'
      } else if (!this.consult.models.AnimalNumbers.signed_at) {
        return 'Please sign the consult'
      }
      return ''
    },
  },
}
</script>
